module.exports = __webpack_public_path__ + "img/ai_music.43848c86.png";